/* eslint-disable */

import React, { Component } from 'react';
import 'AppSrc/core/components/dev-page/style/components/grid-overlay.css';

class GridOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showGrid: true,
    }
    this.toggleGrid = this.toggleGrid.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount(){
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(key) {
    if (key.keyCode === 192) { // when you press the § key
      this.toggleGrid();
    }
  }


  toggleGrid() {
    this.setState((prevState) => ({
      showGrid: !prevState.showGrid,
    }));
  }

  render() {
    return (
      <div className="dev-grid-overlay">
        <button
          className="toggle-grid-button"
          type="button"
          onClick={this.toggleGrid}
        >
          Toggle Grid
        </button>
        {
          this.state.showGrid && (
            <div className="grid-container">
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
              <div className="column" onClick={this.toggleGrid}/>
            </div>
          )
        }
      </div>
    );
  }
}

export { GridOverlay };
